/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Product_PlaceholderInputs */

const en_search_product_placeholder = /** @type {(inputs: Search_Product_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search product...`)
};

const es_search_product_placeholder = /** @type {(inputs: Search_Product_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar producto...`)
};

/**
* | output |
* | --- |
* | "Search product..." |
*
* @param {Search_Product_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_product_placeholder = /** @type {((inputs?: Search_Product_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Product_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_product_placeholder(inputs)
	return es_search_product_placeholder(inputs)
});